export var REDIRECT_COUNT = 'redirectCount';
export var IDENTITY_CSRF_TOKEN = 'avatar.csrf.token';
export function setCookie(key, value) {
  document.cookie = "".concat(key, "=").concat(value, ";path=/;max-age=30");
}
export function getCookieAsInteger(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var regex = new RegExp("".concat(key, "=(\\d+)"));
  var result = document.cookie.match(regex);
  return result ? parseInt(result[1], 10) : defaultValue;
}
export function clearCookie(key) {
  document.cookie = "".concat(key, "=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT");
}